import { useState, useEffect } from 'react';
import AdminLogin from './AdminLogin';
import AdminDashboard from './AdminDashboard';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function AdminPage() {
  const [authenticated, setAuthenticated] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('vertex_admin_token');
    if (token) {
      axios.get(`${API}/admin/me`, {
        headers: { Authorization: `Bearer ${token}` }
      })
        .then(() => setAuthenticated(true))
        .catch(() => {
          localStorage.removeItem('vertex_admin_token');
          localStorage.removeItem('vertex_admin_email');
        })
        .finally(() => setChecking(false));
    } else {
      setChecking(false);
    }
  }, []);

  const handleLogin = () => setAuthenticated(true);
  
  const handleLogout = () => {
    localStorage.removeItem('vertex_admin_token');
    localStorage.removeItem('vertex_admin_email');
    setAuthenticated(false);
  };

  if (checking) {
    return (
      <div className="min-h-screen bg-vertex-950 flex items-center justify-center">
        <div className="text-vertex-400 animate-pulse">Loading...</div>
      </div>
    );
  }

  return authenticated
    ? <AdminDashboard onLogout={handleLogout} />
    : <AdminLogin onLogin={handleLogin} />;
}
